"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ErxNotificationsLink = _interopRequireDefault(require("./ErxNotificationsLink"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _ErxNotificationsLink.default;
exports.default = _default;